import React from "react";
import { Alert } from "@material-ui/lab";
import { Fade } from "@material-ui/core";

const FormMessages = ({ messages = {}, severity = "error" }) => {
	return (
		<div role="status" aria-live="polite" aria-atomic="false">
			{Object.entries(messages).map(([k, v]) => (
				<Fade in key={k}>
					<Alert severity={severity}>{v}</Alert>
				</Fade>
			))}
		</div>
	);
};

export default FormMessages;
